import { SortAscendingIcon, SortDescendingIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { SortButton } from "@/components/SortButton/SortButton";
import { ToggleButtonGroup } from "@/components/ToggleButtonGroup/ToggleButtonGroup";
import {
  FlightsSortOptions,
  type FlightsSortValue,
} from "@/features/flights/types/types";
import { SortOrder } from "@/types/enums";

type Props = {
  value: FlightsSortValue;
  onChange: (newValue: FlightsSortValue) => void;
};

export function FlightsSort({ value, onChange }: Props) {
  const intl = useIntl();

  return (
    <div className="relative w-full">
      <ToggleButtonGroup
        orientation="vertical"
        fullWidth
        size="small"
        color="primary"
        aria-label={intl.formatMessage({
          defaultMessage: "Sort options",
          description:
            "Accessible label for the sort options dropdown or selector",
        })}
      >
        <SortButton
          value={{ field: FlightsSortOptions.PRICE, order: SortOrder.ASC }}
          isSelected={
            value.field === FlightsSortOptions.PRICE &&
            value.order === SortOrder.ASC
          }
          onChange={onChange}
          selectionVariant="radio"
        >
          <SortDescendingIcon size={20} />
          {intl.formatMessage({
            defaultMessage: "Cheapest first",
            description: "Sort option: cheapest flights first",
          })}
        </SortButton>

        <SortButton
          value={{ field: FlightsSortOptions.PRICE, order: SortOrder.DESC }}
          isSelected={
            value.field === FlightsSortOptions.PRICE &&
            value.order === SortOrder.DESC
          }
          onChange={onChange}
          selectionVariant="radio"
        >
          <SortAscendingIcon size={20} />
          {intl.formatMessage({
            defaultMessage: "Expensive first",
            description: "Sort option: most expensive flights first",
          })}
        </SortButton>
      </ToggleButtonGroup>
    </div>
  );
}
